import React from 'react';
import './AdminButtons.css';

const AdminButtons = ({ onSaveCss, onResetCss }) => {
  return (
    <div className="admin-buttons">
      <button 
        className="save-css-button" 
        onClick={onSaveCss}
      >
        <i className="fas fa-save"></i>
        CSS Değişikliklerini Kaydet
      </button>

      <button 
        className="reset-css-button" 
        onClick={onResetCss}
      >
        <i className="fas fa-undo"></i>
        Varsayılan CSS'e Dön
      </button>
    </div>
  );
};

export default AdminButtons; 